import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "~/designSystem/components/Tooltip";

import IconButton from "~/components/Buttons/IconButton";

import { faXmark } from "@fortawesome/pro-regular-svg-icons";

import { useGlobalNewOpportunityModalContext } from "../context";
import { useGlobalCreateOpportunityStore } from "../store";
import { checkFormHasValueWithoutPrePopulatedFields } from "../utils";

export default function CreateOpportunityHeader() {
  const setIsOpenGlobalCreateOpportunity = useGlobalCreateOpportunityStore(
    state => state.setIsOpenGlobalCreateOpportunity,
  );

  const setIsSaveAndNewMode = useGlobalCreateOpportunityStore(
    state => state.setIsSaveAndNewMode,
  );

  const { form } = useGlobalNewOpportunityModalContext();

  const setIsConfirmCloseForm = useGlobalCreateOpportunityStore(
    state => state.setIsConfirmCloseForm,
  );

  const onClose = () => {
    const hasValue = checkFormHasValueWithoutPrePopulatedFields(form);
    if (!!hasValue) {
      setIsConfirmCloseForm(true);
    } else {
      setIsOpenGlobalCreateOpportunity(false);
      setIsSaveAndNewMode(false);
    }
  };

  return (
    <div className="flex w-full justify-between items-center p-3">
      {/* Title section */}
      <p className="text-primary text-sm">New opportunity</p>

      {/* Actions */}
      <Tooltip
        contentText="Close"
        side="top"
        shortcutKey={{ type: "text", value: "ESC" }}
      >
        <IconButton
          type="text"
          size="middle"
          icon={<FontAwesomeIcon icon={faXmark} />}
          onClick={onClose}
        />
      </Tooltip>
    </div>
  );
}
